// import Auth from '../utils/Auth';
// import Notify from './../Common/Notify';
import { siteConfig, apisList } from '../variables/config';
import Security from './Security.services'
import { getToken, getObject, setObject, getAnonymousToken } from './useful'
import * as actions from '../stores/actionsList';
import store from '../stores/storeConfig';
import { nanoid } from 'nanoid';
import SocketServices from './socket.services';
import { Buffer } from 'buffer'

const requestSecurity = new Security()

class HttpService {

    currentUploadIndex

    request(action, params, cb) {

        // console.log(action,params)
        let api = apisList[action]
        if (api) {
            this.checkParams(api, params, (newParams, paramsError) => {
                // console.log(paramsError)

                if (!paramsError) {

                    this.handleFiles(api, newParams, () => {

                        // console.log("request",api)

                        requestSecurity.hashData(newParams, api, (hashedData, hashError) => {
                            if (!hashError) {

                                // console.log('here !apiv1',api)
                                // console.log(JSON.parse(this.serviceMethod(api, hashedData).body))
                                this.checkApiVersion((apiv) => {
                                    // console.log('apiversion', api)
                                    fetch(siteConfig.domain + apiv, this.serviceMethod(api, hashedData))
                                        .then(res => this.handleResponseError(res, (result, err, status) => {
                                            // console.log('err')
                                            // console.log(err)
                                            // console.log(result)
                                            cb(result, err, status)
                                        })).catch(err => {
                                            console.log('errris', err)
                                            cb(null, err)
                                        })
                                })

                            } else {
                                cb(null, { error: "Security prevention" }) // TODO: Language
                            }
                        })
                    })
                } else {
                    cb(null, paramsError) // TODO: Language
                }
            })
        } else {
            cb(null, "Irrelevant request") // TODO: Language
        }
    }

    checkApiVersion(cb) {
        if (getToken()) {
            cb('apiv1')
        } else if (getAnonymousToken()) {
            cb('apiv3')
        } else {
            cb('apiv1')
        }
    }

    addUploadQueque(file, source, rtempId, cb) {

        let tempId = rtempId ?? nanoid()
        // console.log("addUploadQueque")
        // console.log(rtempId)
        // console.log(cb)

        store.dispatch(actions.addQueueFile(file, tempId, source, 'uploads'))

        setTimeout(() => {

            this.checkUploadQueque(cb)

        }, 1000);

    }

    checkUploadQueque(cb) {

        // console.log("checkUploadQueque")

        let uploads = store.getState().queque?.uploads
        // console.log(uploads)
        if (Array.isArray(uploads) && uploads.length > 0) {

            if (this.currentUploadIndex == null) {

                this.currentUploadIndex = true
                let current = uploads[0]
                // console.log(current)
                // console.log('current.source, current.file, current.tempId', current.source, current.file, current.tempId)
                this.startChunkUpload(current.source, current.file, current.tempId, 512000, (info) => {

                    // console.log('inf is o2', info)

                    if (current.source?.type == 'message') {
                        let key = current.source?.key ?? 'file'

                        // console.log(info)
                        // console.log(key)

                        store.dispatch(actions.changeTempMessage(current.source.messenger, current.tempId, { [key]: info, tempFile: null }))
                        setTimeout(() => {
                            SocketServices.sendTheTempMessage(current.tempId, current.source)
                        }, 2000);
                        // this.sendMessengerFileInfo(info, current.source, cb)
                    }

                    if (current.source?.type == 'drive') {
                        // console.log('infosd', info)
                        // console.log(cb)

                        this.sendDriveFileInfo(info, current.source, cb)
                    } else {
                        if (cb) cb(info)
                    }


                    store.dispatch(actions.updateQueueFile(current.tempId, 'done', 'uploads'))


                    setTimeout(() => {
                        this.currentUploadIndex = null

                        // console.log("FINISHED")
                        this.checkUploadQueque(cb)

                    }, 50);
                })
            }
        }

    }
    sendMessengerFileInfo = (info, source, cb) => {

    }
    sendDriveFileInfo = (info, source, cb) => {
        // let file = info.address
        // console.log('info, sourceUPLOADER', info, source)
        // console.log(info)

        info.type = "file"
        info.name = info.orgName ?? info.name
        info.folder = source?.folder
        let index = info.name.lastIndexOf('.')
        info.name = info.name.substring(0, index)
        info.applet = source?.applet
        info.frame = source?.frame

        // let body = { type: "file", file, name: (file.orgName ?? file.name), folder: source?.Folder }
        this.request('addFile', info, (fetchResult, fetchError) => {
            if (fetchError) {
                console.log('err', fetchError)
                return;
            }

            // console.log(cb)

            if (cb) {
                // console.log(fetchResult, fetchError, info)
                cb(fetchResult, fetchError)
            } 
            // else {
            //     console.log("NO CALLBACK")
            // }
            // this.getFiles()
            // console.log("here should get files after uploading")
        })
        // this.request()
    }

    startChunkUpload(source, file, tempId, chunkSize, cb) {
        this.readAndUploadCurrentChunk(source, file, tempId, 0, chunkSize, cb)
    }

    readAndUploadCurrentChunk(source, file, tempId, currentChunkIndex, chunkSize = 512, cb) {

        // console.log('readAndUploadCurrentChunk', source)
        const reader = new FileReader()

        const from = currentChunkIndex * chunkSize;
        const to = from + chunkSize;
        // console.log(file)
        const blob = file.slice(from, to);
        reader.onload = e => this.uploadChank(e, source, file, tempId, currentChunkIndex, chunkSize, cb)
        reader.readAsDataURL(blob)


    }

    uploadChank = (readerEvent, source, file, tempId, currentChunkIndex, chunkSize, cb) => {
        // console.log("uploadChank")
        const data = readerEvent.target.result;
        // console.log(data)
        const filesize = file.size
        let totalChunks = Math.ceil(file.size / chunkSize)

        let object = {
            name: file.name,
            size: filesize,
            currentChunkIndex: currentChunkIndex,
            totalChunks: totalChunks,
            buffer: Buffer.from(data).toString()
        }

        // console.log(object.totalChunks)

        // const params = new URLSearchParams();
        // params.set('name', file.name);
        // params.set('size', filesize);
        // params.set('currentChunkIndex', currentChunkIndex);
        // params.set('totalChunks', Math.ceil(file.size / chunkSize));

        // console.log(object)
        // console.log('1fileChunkuploader', object)
        this.request('fileChunkuploader', object, (fetchResult, fetchError) => {

            const chunks = Math.ceil(filesize / chunkSize) - 1;
            const isLastChunk = currentChunkIndex === chunks;
            // console.log(isLastChunk)

            let percentage = (currentChunkIndex / totalChunks) * 100
            // console.log(percentage)

            if (source.type == 'message') {
                // console.log(tempId)
                // console.log(source.messenger)

                store.dispatch(actions.changeTempMessage(source.messenger, tempId, { precentage: percentage }))
            } else {
                store.dispatch(actions.updateQueueFile(tempId, { precentage: percentage }, 'uploads'))
            }

            if (isLastChunk) {
                // console.log("FINISHED")
                // console.log(currentChunkIndex)
                // console.log(fetchError)
                // console.log(fetchResult)

                if (source.type == 'message') {
                    store.dispatch(actions.changeTempMessage(source.messenger, tempId, { precentage: 100 }))
                } else {
                    store.dispatch(actions.updateQueueFile(tempId, { precentage: 100 }, 'uploads'))

                }
                if (cb) {
                    // console.log('fetcherr', fetchError)
                    cb(fetchResult?.info)
                }
                // file.finalFilename = data.finalFilename;
                // console.log("dddd", file.finalFilename)
                // this.setState({ lastUploadedFileIndex: this.state.currentFileIndex })
                // this.setState({ currentChankIndex: null })
            } else {
                this.readAndUploadCurrentChunk(source, file, tempId, currentChunkIndex + 1, chunkSize, cb)
                // this.setState({ currentChankIndex: this.state.currentChankIndex + 1 })
                // setTimeout(() => {
                //     console.log(this.state.currentChankIndex)
                // }, 200)
            }


        })



    }


    handleFiles(api, newParams, cb) {
        // console.log("handleFiles")
        // console.log(newParams['**files'])
        // console.log(newParams)
        if (!newParams || !newParams['**files']) {
            cb()
            return
        }

        let files = newParams['**files']
        let promises = []
        // console.log(files)
        for (let [key, value] of Object.entries(files)) {
            // console.log(key)
            promises.push(new Promise((resolve, reject) => {
                if (value) {
                    this.fileUpload(value, newParams['applet'], key, (fileInfo) => {
                        // console.log(fileInfo)
                        // let index = null
                        // if (key.includes('*')) {
                        //     console.log(key)
                        //     key = key.split('*')
                        //     index = key[1]
                        //     key = key[0]
                        //     console.log(key)
                        //     console.log(index)
                        // }
                        if (Array.isArray(fileInfo)) {
                            newParams[key] = Array.isArray(newParams[key]) ? newParams[key] : []
                            setObject(newParams, key, [...fileInfo], true)
                        } else {
                            // console.log("newParams")
                            // console.log("key", key)

                            setObject(newParams, key, fileInfo)
                        }
                        resolve(fileInfo)
                    })
                } else {
                    resolve()
                }
            }))

        }
        // console.log(newParams)
        Promise.all(promises).then(() => {
            delete newParams['**files']
            cb()
        })

    }



    fileUpload(files, page, field, cb) {

        // console.log("UPLOAD")
        let fetchAddress = 'files/fileuploader'

        let filesInfo = []
        let count = 0

        let allFiles = Array.isArray(files) ? files : [files]

        allFiles.forEach((file, i) => {

            // if (file.formType === 'ImageInput') {
            //     fetchAddress = 'files/imageuploader'
            // }
            // if (file.formType === 'VideoInput') {
            //     fetchAddress = 'files/videouploader'
            // }

            const req = new XMLHttpRequest();
            var formData = new FormData();

            if (file) {
                formData.append('file', file);
            }

            formData.append('field', field);
            formData.append('page', page);

            console.log(fetchAddress)
            req.open("POST", siteConfig.domain + fetchAddress, true);
            let parent = this

            req.upload.onprogress = function (e) {
                // console.log(e)
                let percentage = Math.floor((e.loaded / e.total) * 100)
                // let uploads = parent.state.uploads
                // uploads.forEach((upload, index) => {
                //     if (upload.key == field + i) {
                //         uploads[index].percentage = percentage
                //     }
                // });
                // parent.setState(uploads)
            }

            req.onload = function (e) {
                if (req.readyState === 4) {
                    console.log(req)
                    if (req.status === 200) {
                        let data = JSON.parse(req.responseText);
                        // let data = this.handleResponseError(req.responseText)

                        if (!Array.isArray(files)) {
                            filesInfo = data.info
                            cb(filesInfo)
                        } else {
                            filesInfo.push(data.info)
                            count = count + 1
                            if (count === files.length) {
                                cb(filesInfo)
                            }
                        }

                    } else {
                        cb(false)
                        console.error(req.statusText);
                    }
                }
            }.bind(this);
            req.onerror = function (e) {
                console.error(req.statusText);
            };

            req.send(formData);

        });
    }


    urlShaderrequest(action, params, cb) {
        let api = apisList[action]
        if (api) {
            this.checkParams(api, params, (chekcedParams, paramsError) => {
                console.log("HERE")
                if (!paramsError) {
                    requestSecurity.hashData(params, api, (hashedData, hashError) => {
                        if (!hashError) {
                            fetch(siteConfig.domain + '/apiv1', this.serviceMethod(api, hashedData))
                                .then(res => this.handleResponseError(res))
                                .then((data, err) => cb(data, err))
                                .catch(err => {
                                    // console.log('eEEE')
                                    cb(null, err)
                                })
                        } else {
                            cb(null, { error: "Security prevention" }) // TODO: Language
                        }
                    })
                } else {
                    cb(null, { error: paramsError }) // TODO: Language
                }
            })
        } else {
            cb(null, "Irrelevant request") // TODO: Language
        }
    }

    chooseServer() {
        // TODO :FUTURE
    }


    checkParams(api, params, cb) {
        let newParams = {}
        let errors = {}
        api.params.forEach(param => {
            newParams[param.key] = params[param.key]
            if (param.required) {
                if (params[param.key] == null && params[param.key] == '') {
                    // cb(null, {
                    errors[param.key] = '{{lang}}feildIsRequired'
                    // })

                }
                if (param.type && typeof params[param.key] != param.type) {

                    // cb(null, {
                    errors[param.key] = '{{lang}}invalidInputs'
                    // })
                }
            }
        });
        if (api.flexibleParams) {
            cb(params)
        } else {
            // console.log((errors != {}) ? errors : null)

            cb(newParams, errors.length ? errors : null)
        }
    }

    serviceMethod(api, data) {
        // console.log('tp1')
        let request;
        const method = { method: api.method ? api.method.toUpperCase() : 'POST' }
        const Body = { body: JSON.stringify(data) }
        const AddProperty = {};
        const headers = { 'Content-Type': 'application/json', 'Accept': 'application/json', } //, 'Authorization': 'bearer ' + Auth.getToken(), ...custom_header });
        if (api.auth === 'token') {
            let token = getToken()
            // console.log(token)
            if (token) {
                headers.Authorization = "bearer " + token
            } else {
                let anonymousToken = getAnonymousToken()
                if (anonymousToken) {
                    headers.Authorization = "bearer " + anonymousToken
                }
                /// TO DO
            }
        }
        switch (method.method) {
            case 'GET':
                request = { ...method, headers, ...AddProperty }
                break;
            case 'POST':
                request = { ...method, headers, ...AddProperty, ...Body }
                break;
            case 'DELETE':
                request = { ...method, headers, ...AddProperty }
                break;
            case 'PUT':
                request = { ...method, headers, ...AddProperty, ...Body }
                break;
            default:
                break;
        }

        // console.log(request)

        // console.log('tp2')
        return request
    }

    handleResponseError(res, cb) {
        // console.log('handleResponseError',res)
        res.json().then(result => {
            // console.log(res)
            if (!res.ok) {

                cb(null, result, res.status)
                // return { result: null, err: result }
                // throw new Error("HTTP error, status = " + res.status);
            } else {
                // return { result }
                cb(result, null, res.status)
            }
        }).catch(err => {
            console.log(err)
        })

    }

    async handlerResponseService(data) {
        // console.log('handlerResponseService', data);
        if (data && data.responseMessages) {
            for (let item of data.responseMessages) {
                // await Notify.notifycation({
                //     msg: `${item.name ? item.name + ': ' : ''} ${item.message}`,
                //     type: data.success ? 'success' : 'error',
                //     position: 'bottom-right'
                // })
            }
        }

        return data;
    }

    handleError(error) {
        console.log(error.message);
    }

}


export default new HttpService();